
import { throttle } from 'utils/misc'

function updateDetailedProductRibbons(productsToUpdate) {
    const gallery = document.querySelector(
        '#product-details-form .slider-wrapper',
    )

    const ribbonAlreadyExists = gallery.getElementsByClassName('ribbon-wrapper')
    if (ribbonAlreadyExists?.length) return

    const ribbonWrapper = document.createElement('div')

    ribbonWrapper.className = 'ribbon-wrapper'

    productsToUpdate.forEach(product => {
        product.HtmlSnippets?.forEach(snippet => {
            ribbonWrapper.innerHTML += snippet
        })
    })

    gallery.append(ribbonWrapper)
}

function updateProductGridRibbons(productsToUpdate) {
    const productsInList = document.querySelectorAll('.product-item')

    productsInList.forEach(product => {
        const match = productsToUpdate.find(
            productsToUpdate =>
                productsToUpdate.ProductId == product.dataset.productId,
        )

        if (match) {
            const pic = product.querySelector('figure')

            const ribbonWrapper = document.createElement('div')
            ribbonWrapper.className = 'ribbon-wrapper'

            match.HtmlSnippets?.forEach(snippet => {
                ribbonWrapper.innerHTML += snippet
            })

            pic.append(ribbonWrapper)
        }
    })
}

function fetchSingleRibbon(detailsProductId) {
    const body = JSON.stringify({ detailsProductId })

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body,
    }

    fetch('/getribbons', options)
        .then(res => res.json())
        .then(productsToUpdate => {
            if (!productsToUpdate || !productsToUpdate.length) {
                return
            }

            updateDetailedProductRibbons(productsToUpdate)
        })
}

function fetchMultipleRibbons(categoryProductIds) {
    const body = JSON.stringify({
        categoryProductIds,
    })

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body,
    }

    fetch('/getribbons', options)
        .then(res => res.json())
        .then(productsToUpdate => {
            if (!productsToUpdate || !productsToUpdate.length) {
                return
            }

            updateProductGridRibbons(productsToUpdate)
        })
}

async function productRibbons() {
    const productsInList = document.querySelectorAll('.product-item')

    const productDetailsForm = document.getElementById('product-details-form')

    if (productDetailsForm) {
        const { productId } = productDetailsForm.dataset

        fetchSingleRibbon(Number(productId))
    }

    // If any product grid exists, get those product ribbons
    if (productsInList.length) {
        const categoryProductIds = [].map.call(
            productsInList,
            product => Number(product.dataset.productId),
        )

        fetchMultipleRibbons(categoryProductIds)
    }
}

export default productRibbons
